/**
 * Provides a simple interface for local/session storage.
 */
export interface Storage {
  getItem(key: string): string | null
  removeItem(key: string): void
  setItem(key: string, value: string): void
}

export const localStorage = getStorage(window.localStorage)
export const sessionStorage = getStorage(window.sessionStorage)

// In Private Mode on iOS, setting items in the storage fails.
// We wrap it to make sure we can make it at least not crash.
function getStorage(storage: globalThis.Storage): Storage {
  try {
    storage.setItem('supported', 'true')
    storage.removeItem('supported')
  } catch {
    const map = new Map<string, string>()
    return {
      getItem: (item) => {
        const r = map.get(item)
        return r ?? null
      },
      setItem: (item, value) =>
        map.set(
          item,
          value === undefined || value === null ? value : value.toString(),
        ),
      removeItem: (item) => map.delete(item),
    } satisfies Storage
  }
  return storage as Storage
}
